import type { IconProps } from './IconProps';

export const DotIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 16"
    fill="none"
    width={props.width ?? 10}
    height={props.height ?? 16}
    {...props}
  >
    <circle cx="5" cy="8" r="3.5" fill="#FF656D" />
  </svg>
);
